<template>
  <form-area
    ref="schForm"
    class="flex-box vertical"
    layout="horizontal"
    hide-btn
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
    :items="items"
    :entity="schedule"
    :extra-rules="extraRules"
    confirm-text="提交">
    <template v-slot:form="{form}">
      <a-form-model-item label="关联任务" prop="task" :wrapper-col="{span: 24}">
        <a-table :columns="taskColumns" :data-source="form.task || []" bordered :pagination="false">
          <template v-slot:name="text, record">
            <a-textarea v-model="record.name" placeholder="请输入" :rows="3" style="width: 300px"></a-textarea>
          </template>
          <template v-slot:temp="text, record">
            <a-select
              v-model="record.temp_id"
              :options="options"
              placeholder="请选择"
              @change="handleTaskTempChange($event, record)"></a-select>
          </template>
          <template v-slot:action="text, record, index">
            <a class="txt-btn danger" @click.stop="delTask(form.task, index)">删除</a>
          </template>
        </a-table>
        <a-button size="small" type="primary" @click="addTask(form)" class="add-sch-task">
          <a-icon type="plus-circle" />添加任务
        </a-button>
      </a-form-model-item>
    </template>
  </form-area>
</template>

<script>
    import {getActivityTaskId, getSchFormItems} from "../../../common/activity/schedule";

    export default {
        name: "SchForm",
        props: {
            activity: Object,
            schedule: {
                type: Object,
                default() {
                    return {};
                }
            },
            labelCol: Object,
            wrapperCol: Object,
        },
        data() {
            return {
                extraRules: {
                    task: [
                        { required: true, message: '请添加日程任务', trigger: 'change' },
                        {
                            validator: (rule, value, callback) => {
                                let error = "";
                                if (value && value.length > 0) {
                                    for(let i = 0, l = value.length; i < l; i++) {
                                        const item = value[i];
                                        if(!item.name) {
                                            error = `请输入第${i + 1}个任务的任务名称`;
                                            break;
                                        }
                                    }
                                } else {
                                    error = "请添加日程任务";
                                }
                                if(error) {
                                    callback(new Error(error));
                                } else {
                                    callback();
                                }
                            },
                            trigger: 'change'
                        }
                    ]
                },
                taskColumns: [
                    {title: '任务ID', dataIndex: 'task_sort', width: '25%', customRender: text => this.schedule ? getActivityTaskId(this.schedule.activity_id, text) : '--'},
                    {title: '任务', dataIndex: 'name', width: '25%', scopedSlots: { customRender: 'name'}},
                    {title: '关联固定任务', dataIndex: 'temp', width: '30%', scopedSlots: { customRender: 'temp'}},
                    {title: '操作', key: 'action', width: '20%', scopedSlots: { customRender: 'action'}}
                ],
                options: []
            }
        },
        computed: {
            items() {
                let res = [];
                const activity = this.activity;
                if(activity) {
                    res = getSchFormItems(activity);
                }
                return res;
            }
        },
        created() {
            this.getTaskTemp();
        },
        methods: {
            handleTaskTempChange(val, item) {
                if(val > 0) {
                    const temp = this.options.find(o => o.key == val);
                    this.$set(item, 'module_ids', temp.module_ids);
                    this.$set(item, 'guide_book', temp.file);
                } else {
                    this.$set(item, 'module_ids', null);
                    this.$set(item, 'guide_book', null);
                }
            },
            addTask(form) {
                if(form.task) {
                    form.task.push({
                        key: form.task.length,
                        temp_id: 0
                    });
                } else {
                    this.$set(form, 'task', [{
                        key: 0,
                        temp_id: 0
                    }]);
                }
            },
            delTask(task, index) {
                task.splice(index, 1);
            },
            getTaskTemp() {
                const url = "/activity/activity-task-temp?pageSize=1000";
                this.$axios(url).then(res => {
                    const tempList = res.data.map(item => new Object({
                        key: item.id,
                        title: item.name,
                        module_ids: item.module_ids,
                        file: item.file,
                    }));
                    tempList.push({key: 0, title: '--'});
                    this.options = tempList;
                });
            }
        }
    }
</script>

<style lang="less">
.add-sch-task {
  position: absolute;
  right: 0;
  top: -30px;
}
</style>
